<template>
    <div class="notification-controller" />
</template>

<script>
import { defineComponent } from 'vue';
import { showMessageNotification, sseService } from '@/utils';

export default defineComponent({
    name: 'NotificationController',
    data() {
        return {
            unsubscribes: [],
        };
    },
    mounted() {
        const unsubscribeConnected = sseService.subscribe(
            'connected',
            this.onConnected,
        );
        const unsubscribeNotification = sseService.subscribe(
            'notification',
            this.onNotification,
        );

        const unsubscribeCheckAuth = sseService.subscribe(
            'checkAuth',
            this.onCheckAuth,
        );

        this.unsubscribes.push(
            unsubscribeConnected,
            unsubscribeNotification,
            unsubscribeCheckAuth,
        );
    },
    beforeUnmount() {
        this.unsubscribes.forEach((unsubscribe) => {
            if (typeof unsubscribe === 'function') {
                unsubscribe();
            }
        });
        this.unsubscribes = [];
    },
    methods: {
        onConnected() {
            console.warn('[SSE]: ✅ connected');
        },
        onNotification(data) {
            try {
                if (data?.message) {
                    showMessageNotification(data.message);
                }
            } catch (error) {
                console.error('NotificationController: onNotification failed', error);
            }
        },
        async onCheckAuth() {
            try {
                await this.$http.get('/auth');
            } catch (error) {
                console.error('NotificationController: /auth request failed', error);
            }
        },
    },
});
</script>
